import { render, staticRenderFns } from "./roleTable.vue?vue&type=template&id=726afbc8"
import script from "./roleTable.vue?vue&type=script&lang=js"
export * from "./roleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports